module.exports = __webpack_public_path__ + "static/media/plusIcon.d0893b59.svg";